import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { openRemoteModalWrapper } from 'src/components/pages/legacy/components/open-legacy-remote-modal-link';
import { useAuthorization } from 'src/hooks/use-authorization';
import { useUrls } from 'src/hooks/use-urls';

export const useContactNoteUrl = () => {
  const { getEditContactNoteUrl, getAddContactNoteUrl } = useUrls();
  const { getFeatureFlag } = useAuthorization();
  const showInlineForm =
    getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
  const history = useHistory();

  const getContactNoteModalUrl = useCallback(
    (contactNoteId: number, contactId: number) =>
      getEditContactNoteUrl({
        contactNoteId,
        contactId,
        options: { includeHost: !showInlineForm },
      }),
    [showInlineForm, getEditContactNoteUrl],
  );

  const showEditContactNoteModal = useCallback(
    (contactNoteId: number, contactId: number) => {
      const contactNoteModalUrl = getContactNoteModalUrl(contactNoteId, contactId);
      if (showInlineForm) {
        history.push(contactNoteModalUrl);
      } else {
        openRemoteModalWrapper(contactNoteModalUrl);
      }
    },
    [getContactNoteModalUrl, showInlineForm, history],
  );

  const showAddContactNoteModal = useCallback(
    (contactId: number) => {
      const contactNoteModalUrl = getAddContactNoteUrl(contactId);
      if (showInlineForm) {
        history.push(contactNoteModalUrl);
      } else {
        openRemoteModalWrapper(contactNoteModalUrl);
      }
    },
    [showInlineForm, getAddContactNoteUrl, history],
  );

  return { showEditContactNoteModal, showAddContactNoteModal, getContactNoteModalUrl };
};
